module.exports = __webpack_public_path__ + "static/img/u49.3bdf5000.png";